import { createContext, useContext } from 'react';
import { useFacebookPixel, useGoogleAnalytics, useSmartlook } from '../hooks';
import Script from 'next/script'; // import useSegment from '../hooks/use-segment';
// import useMixpanel from '../hooks/use-mixpanel';

import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';
import usePostHogProvider from '../hooks/use-posthog-provider';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AnalyticsContext = /*#__PURE__*/createContext({
  isActive: false,
  trackEvent: function trackEvent(event, prop) {
    return null;
  },
  trackPHEvent: function trackPHEvent(event, prop) {
    return null;
  },
  startRecording: function startRecording() {
    return null;
  },
  fbTrackWorkerApplied: function fbTrackWorkerApplied() {
    return null;
  },
  fbTrackWorkerStartsApplication: function fbTrackWorkerStartsApplication() {
    return null;
  },
  fbTrackWorkerAppliesSpontaneously: function fbTrackWorkerAppliesSpontaneously() {
    return null;
  }
});
var isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'; // const clarityProjectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID ?? '';

export var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var children = _ref.children;

  // const { isActive, trackEvent } = useMixpanel();
  var _usePostHogProvider = usePostHogProvider(),
      trackPHEvent = _usePostHogProvider.trackEvent; // const { isActive, trackEvent } = useSegment();


  var _useSmartlook = useSmartlook(),
      startRecording = _useSmartlook.initialize;

  useGoogleAnalytics();

  var _useFacebookPixel = useFacebookPixel(),
      fbTrackWorkerApplied = _useFacebookPixel.trackWorkerApplied,
      fbTrackWorkerStartsApplication = _useFacebookPixel.trackWorkerStartsApplication,
      fbTrackWorkerAppliesSpontaneously = _useFacebookPixel.trackWorkerAppliesSpontaneously;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isProd && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Script, {
        strategy: "lazyOnload",
        async: true,
        src: "https://www.googletagmanager.com/gtag/js?id=AW-622219312"
      }), /*#__PURE__*/_jsx(Script, {
        strategy: "lazyOnload",
        children: "window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config','AW-622219312');"
      })]
    }), /*#__PURE__*/_jsx(PostHogProvider, {
      client: posthog,
      children: /*#__PURE__*/_jsx(AnalyticsContext.Provider, {
        value: {
          isActive: false,
          trackEvent: trackPHEvent,
          startRecording: startRecording,
          fbTrackWorkerApplied: fbTrackWorkerApplied,
          fbTrackWorkerStartsApplication: fbTrackWorkerStartsApplication,
          fbTrackWorkerAppliesSpontaneously: fbTrackWorkerAppliesSpontaneously,
          trackPHEvent: trackPHEvent
        },
        children: children
      })
    })]
  });
};
export var useAnalytics = function useAnalytics() {
  var context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalytics must be used within a AnalyticsProvider');
  }

  return context;
};
export var trackEmployerFreekiumSignupGtag = function trackEmployerFreekiumSignupGtag() {
  if (window && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-622219312/lP8KCLPA68YaELCg2agC'
    });
  }
};
export var trackWorkerAppliesForJP = function trackWorkerAppliesForJP() {
  if (window && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-622219312/9ejYCOqu150bELCg2agC'
    });
  }
};
export var trackWorkerAppliesForShowcase = function trackWorkerAppliesForShowcase() {
  if (window && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-622219312/v-c9CO2u150bELCg2agC'
    });
  }
};
export var trackWorkerSavesTheResearch = function trackWorkerSavesTheResearch() {
  if (window && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-622219312/ljnfCPCu150bELCg2agC'
    });
  }
};